import { z } from "zod";

export const Conflict = z.object({
  shortage: z.number(),
  required: z.number(),
});

export const Created = z.string().array();

export const Err = z.string();
